import { useState, useEffect } from "react";
import { trustStats } from "@/mocks/categories";

export default function HeroSection() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <section className="relative w-full min-h-[520px] md:min-h-[620px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20minimalist%20workspace%20flat%20lay%20with%20laptop%20displaying%20colorful%20spreadsheet%20dashboard%2C%20surrounded%20by%20elegant%20stationery%2C%20small%20terracotta%20pot%20with%20green%20succulent%2C%20ceramic%20coffee%20mug%2C%20soft%20natural%20daylight%20from%20left%2C%20cream%20and%20warm%20beige%20background%2C%20clean%20editorial%20productivity%20photography%2C%20gentle%20shadows%2C%20high%20detail%2C%20harmonious%20warm%20neutral%20composition&width=1600&height=900&seq=hero-main-2026x2&orientation=landscape"
          alt="GTBuy Spreadsheet workspace with order tracking system on laptop"
          title="GTBuy Spreadsheet Order Management System"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/45"></div>

      <div className="relative z-10 w-full px-4 md:px-6 max-w-6xl mx-auto text-center pt-8">
        <div className={`transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <h1 className="font-heading text-2xl md:text-4xl lg:text-5xl font-bold text-white leading-tight max-w-4xl mx-auto">
            GTBuy Spreadsheet, Kakobuy Spreadsheet &amp; Superbuy Spreadsheet Management System
          </h1>
          <p className="mt-4 md:mt-5 text-sm md:text-lg text-white/85 max-w-2xl mx-auto leading-relaxed">
            A powerful spreadsheet-based tracking system for managing purchases, orders, and logistics across GTBuy, Kakobuy, and Superbuy platforms &mdash; all in one place.
          </p>

          <div className="mt-7 md:mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm md:text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <i className="ri-shopping-cart-2-line w-5 h-5 flex items-center justify-center"></i>
              gtbuy sheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="whitespace-nowrap inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-white font-semibold text-sm md:text-base hover:bg-accent-600 transition-all duration-300 cursor-pointer hover:scale-105"
            >
              <i className="ri-flashlight-line w-5 h-5 flex items-center justify-center"></i>
              buy it now
            </a>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 bg-background-50/90 backdrop-blur-sm border-t border-background-200/60">
        <div className="max-w-6xl mx-auto px-4 md:px-6 py-5 flex flex-wrap items-center justify-center gap-6 md:gap-12">
          {trustStats.map((stat) => (
            <div key={stat.label} className="text-center">
              <p className="font-heading text-xl md:text-2xl font-bold text-primary-600">{stat.value}</p>
              <p className="text-xs md:text-sm text-foreground-600 mt-0.5">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}